{
  "readyMessage": "Bruk søkefeltet for å se resultater.",
  "emptyMessage": "Ingen treff.",
  "emptyDescription": "Prøv et annet søk.",
  "loadingMessage": "Laster data...",
  "errorMessage": "Kunne ikke hente data. Prøv igjen."
}
